import { Arrows }   from './Isometry.Controls.Arrows' 
import { useBreak } from 'hooks/useBreak'
import { ParentArrows } from './Isometry.ParentControls.Arrows'

export const Controls = ({ isometryToggle, ...props }) => {

  const isMobile = useBreak('md_dn')

  return (
    <>
      {
        props.frames.length > 1 ? <>
        {
          isometryToggle ? <ParentArrows {...props}/> : <Arrows {...props}/>
        }
        
        </> : <>
          <div style={{border:'0px solid blue', flex:`0 0 ${ isMobile ? 140 : 80 }px`}}/>
        </>
      }      
    </>
  )
  
}